// extracted by mini-css-extract-plugin
module.exports = {"animationContainer":"styles_animationContainer__OcHNR","hide":"styles_hide__b6QAm"};